import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { MsalBroadcastService, MsalGuard, MsalModule, MsalService } from '@azure/msal-angular';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './authentication.msal.config';
import { environment } from '../../environments/environment';

import { AuthRoutingModule } from './authentication.routing';
import { SharedModule } from '../shared/shared.module';

import { AuthGuard } from './guards/auth.guard';
import { MsalRedirectGuard } from './guards/msal-redirect.guard';

import { AuthenticationComponent } from './authentication.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { RegisterFormComponent } from "@app/authentication/components/register-form/register-form.component";

import { AuthenticationInfoModalComponent } from "@app/authentication/components";
import { AuthenticationService } from './services/authentication.service';
import { IntroGuard } from '@app/authentication/guards/intro.guard';
import { MilkrunGuard } from '@app/authentication/guards/milkrun.guard';
import { PermissionService } from "@app/authentication/services/permission.service";
import { PermissionBasedGuard } from "@app/authentication/guards/permission-based-auth.guard";
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { UpdateBoschIdComponent } from './components/update-bosch-id/update-bosch-id.component';
import { PasswordConfirmModalComponent } from './components/password-confirm-modal/password-confirm-modal.component';
import { ProdGuard } from "@app/authentication/guards/prod.guard";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";

@NgModule({
    declarations: [
        AuthenticationComponent,
        LoginFormComponent,
        AuthenticationInfoModalComponent,
        ForgotPasswordComponent,
        RegisterFormComponent,
        LoginComponent,
        UpdateBoschIdComponent,
        PasswordConfirmModalComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule,
        SharedModule,
        AuthRoutingModule,
        FormsModule,
        ...(environment.msalEnable ? [
            MsalModule.forRoot(
                MSALInstanceFactory(),
                MSALGuardConfigFactory(),
                MSALInterceptorConfigFactory()
            )
        ] : []),
    ],
    providers: [
        AuthenticationService,
        PermissionService,
        AuthGuard,
        MsalRedirectGuard,
        IntroGuard,
        MilkrunGuard,
        PermissionBasedGuard,
        ProdGuard,
        {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
        JwtHelperService,
        ...(environment.msalEnable ? [
            MsalGuard,
            MsalService,
            MsalBroadcastService
        ] : [])
    ],
    exports: [
        ...(environment.msalEnable ? [MsalModule] : [])
    ],
    bootstrap: []
})
export class AuthenticationModule {
}
